import { Box, ImageListItem, Typography } from '@mui/material';
import Coffee from '../../assets/gifs/loadingCoffee.gif';

const styledCoffeeGif = {
  width: '100%',
  display: 'inline-block',
  maxWidth: 500,
  height: '80%',
};
const LoadingCoffee = () => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <ImageListItem sx={styledCoffeeGif}>
        <img alt='Coffee' style={{ height: '400px' }} src={Coffee}></img>
      </ImageListItem>
      {Coffee ? (
        <Typography
          variant='h5'
          color='initial'
          sx={{ width: '80%', height: '10%', mx: 'auto' }}>
          Enjoy your break while we take you to your destination..
        </Typography>
      ) : null}
    </Box>
  );
};

export default LoadingCoffee;
